import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgYoutube(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      viewBox: "0 0 78.2 78.2",
      fill: "currentColor",
      children: [/*#__PURE__*/jsx("path", {
        d: "M32 47.67l17.55-9.1L32 29.41zm0 0"
      }), /*#__PURE__*/jsx("path", {
        d: "M39.1 0a39.1 39.1 0 1039.1 39.1A39.1 39.1 0 0039.1 0zm26.64 52.15a7 7 0 01-6 5.42 185 185 0 01-20.67.77 185.22 185.22 0 01-20.68-.77 7 7 0 01-6-5.42c-1-4.18-1-8.74-1-13s0-8.87 1-13a7 7 0 016-5.43 187.64 187.64 0 0120.68-.76 187.37 187.37 0 0120.67.76 7 7 0 016 5.43c1 4.18 1 8.75 1 13.05a59.21 59.21 0 01-1 13zm0 0"
      })]
    })
  }));
}

export { SvgYoutube as default };
